import { ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IContentAreaProps, IState } from "../types";
import MainModule from "../modules/mainModule";
import { useTheme } from "@mui/material";
// import { requestFullscreen } from "../system/utils";

const padding = 16;

const ContentArea = (props: IContentAreaProps): ReactElement => {
  const theme = useTheme();
  const [controller, setController] = useState<any>(null);
  const dataContext = useSelector((state: IState) => state.dataContext);
  const newProps = { ...props, parentSize: { width: props.parentSize.width - padding, height: props.parentSize.height - padding - 2 } };

  useEffect(() => {
    if (dataContext) {
      MainModule.getController().then(controller => {
        setController(controller);
      });
    }
  }, [dataContext]);


  // useEffect(() => {
  //   requestFullscreen();
  // }, []);

  return(
    <div className="content-area" style={{ ...props.parentSize, background: theme.palette.background.default }}>
      {dataContext && controller && controller.getView(dataContext, newProps)}
    </div>
  );
};

export default ContentArea;
